import { type StateCreator } from 'zustand';

export type ShowFirstUploadPromptSlice = {
  showFirstUploadPrompt: Record<string, boolean>;
  setShowFirstUploadPrompt: ({ workspaceId, value }: { workspaceId: string; value: boolean }) => void;
  clearShowFirstUploadPrompt: (workspaceId: string) => void;
};

export const createShowFirstUploadPromptSlice: StateCreator<
  ShowFirstUploadPromptSlice,
  [],
  [],
  ShowFirstUploadPromptSlice
> = (set) => ({
  showFirstUploadPrompt: {},
  setShowFirstUploadPrompt: ({ workspaceId, value }) =>
    set((state) => ({ showFirstUploadPrompt: { ...state.showFirstUploadPrompt, [workspaceId]: value } })),
  clearShowFirstUploadPrompt: (workspaceId) =>
    set((state) => ({ showFirstUploadPrompt: { ...state.showFirstUploadPrompt, [workspaceId]: false } })),
});
